<div class="comment-send-box" id="comments">
  <!-- comment form title -->
  <h3 class="comment-send-box__title">
    {{ 'global.comment_send' | translate }}
  </h3>

  <!-- replay mode -->

  @if (replayComment) {
    <div class="comment-send-box__replay">
      <!-- replay comment -->
      <p class="comment-send-box__replay-text">
        {{ 'global.replayToComment' | translate }}
        <span class="text-primary-dark">{{ replayComment }}</span>
      </p>
      <!-- close replay button -->
      <button
        class="comment-send-box__replay-close"
        type="button"
        (click)="onCloseReplay()">
        <i class="iconsax" icon-name="x"></i>
      </button>
    </div>
  }

  @if (userData) {
    <form
      class="comment-send-box__form"
      [formGroup]="commentForm"
      (submit)="submitComment()">
      <!-- form inputs -->
      <div class="comment-send-box__fields">
        <!-- description input -->
        <pwj-input
          class="textarea"
          icon="stickynote"
          iconPosition="left"
          [isTextAreaMode]="true"
          placeholder="global.description"
          label="global.description"
          rows="5"
          formControlName="comment">
        </pwj-input>
      </div>

      <!-- submit button -->
      @if (isUserLoggedIn) {
        <div class="comment-send-box__submit-btn">
          <!-- submit btn -->
          <pwj-button
            variant="primary"
            size="large"
            icon="chevron-right"
            [rotateIconInRtl]="true"
            [iconReversePosition]="true"
            type="submit"
            [disabled]="
              commentForm.invalid || isDisabledSubmitBtn || formIsSubmitting
            "
            >{{ 'global.confirmation' | translate }}</pwj-button
          >
        </div>
      } @else {
        <div>
          <pwj-register-button title="global.confirmation"></pwj-register-button>
        </div>
      }
    </form>
  } @else {
    <div class="comment-send-box__login-box">
      <!-- comment image -->
      <img
        class="comment-send-box__comment-image"
        ngSrc="assets/images/comments.svg"
        width="86"
        height="76"
        alt="" />

      <!-- login alert -->
      <p class="comment-send-box__login-text">
        {{ 'global.loginToComment' | translate }}
      </p>

      <div class="comment-send-box__login-btns">
        <!-- login button -->
        <a [href]="panelUrl + '/login'">
          <pwj-button
            variant="secondary"
            size="large"
            icon="chevron-right"
            [rotateIconInRtl]="true"
            [iconReversePosition]="true"
            type="button"
            >{{ 'global.login' | translate }}</pwj-button
          >
        </a>

        <!-- signup button -->
        <a [href]="panelUrl + '/signup'">
          <pwj-button
            variant="primary"
            size="large"
            icon="chevron-right"
            [rotateIconInRtl]="true"
            [iconReversePosition]="true"
            type="button"
            >{{ 'global.signup' | translate }}</pwj-button
          >
        </a>
      </div>
    </div>
  }
</div>
